<template>
  <el-dialog title="成为合伙人" width="450px" :visible.sync="dialogVisible" append-to-body :fullscreen="device==='mobile'" @close="dialogClose">
    <el-form ref="partnerForm" :model="detail" :rules="partnerRules" label-width="100px">
      <el-form-item label="用户昵称">
        <div class="el-input el-input--small">
          <span class="el-input__inner">{{ detail.nickName }}</span>
        </div>
      </el-form-item>
      <el-form-item label="合伙人身份" prop="partnership">
        <el-select v-model="detail.partnership" placeholder="请选择合伙人身份">
          <el-option label="合作商" :value="3" />
          <el-option label="联盟企业" :value="4" />
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogClose">取　消</el-button>
      <el-button type="primary" @click="handleSubmit">确　定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { changePartnership } from '@/api/member'

export default {
  name: 'UserPartner',
  emits: ['submit'],
  props: {
    show: Boolean,
    value: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      detail: {},
      dialogVisible: false,
      partnerRules: {
        partnership: [{ required: true, message: '请选择合伙人身份', trigger: 'change' }]
      }
    }
  },
  computed: mapGetters(['device']),
  watch: {
    show: {
      immediate: true,
      handler(value) {
        this.dialogVisible = value
      }
    },
    value: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.detail = Object.assign({}, newValue)
      }
    }
  },
  methods: {
    dialogClose() {
      this.dialogVisible = false
      this.$emit('update:show', false)
    },
    handleSubmit() {
      if (!this.detail.partnership) return this.$message.warning('请选择合伙人身份')

      this.$refs.partnerForm.validate(valid => {
        if (!valid) return false
        const data = {
          id: this.detail.id,
          partnership: this.detail.partnership
        }
        changePartnership(data).then(response => {
          if (response) {
            this.$emit('input', this.detail)
            this.$emit('submit')
            this.dialogClose()
          }
        }).catch(() => {})
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
